export default __webpack_public_path__ + "16c3359fd52b6ede22b2be09d4e6670f.png";